import React, { cloneElement } from "react";

import { TableHeaderRow } from "@devexpress/dx-react-grid-material-ui";
import { TableCell, TableRow, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  select: {
    paddingLeft: `0 !important`,
    textAlign: "left",
    width: 32,
  },
  label: {
    paddingLeft: theme.spacing(1),
  },
}));

export default function Header({ compact }) {
  const classes = useStyles();

  const props = compact && {
    cellComponent: () => false,
    rowComponent: ({ children }) => {
      let select = children.find((child) => child.key === "Symbol(select)");
      if (select) {
        select = cloneElement(select, {
          className: classes.select,
        });
      }

      return (
        <TableRow>
          {select && (
            <React.Fragment>
              {select}
              <TableCell
                className={classes.label}
                colSpan={children.length - 1}
              >
                <label>Select All</label>
              </TableCell>
            </React.Fragment>
          )}
        </TableRow>
      );
    },
  };

  return <TableHeaderRow showSortingControls {...props} />;
}
